function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M994.365,748.249h-63.146v-657h63.146c16.635,0,30.132-13.357,30.132-30s-13.497-30-30.132-30H30.132 C13.497,31.249,0,44.606,0,61.249s13.497,30,30.132,30h63.086v657H30.132c-16.635,0-30.132,13.357-30.132,30 c0,16.643,13.497,30,30.132,30h964.233c16.635,0,30.132-13.357,30.132-30C1024.497,761.605,1011.001,748.249,994.365,748.249z  M153.219,91.249h718v657h-718V91.249z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M594.516,933.249h-56.61c1.064-3,1.312-6.288,1.312-9.732v-34.142c0-16.643-13.364-30.132-30-30.132 c-16.635,0-30,13.489-30,30.132v34.142c0,3.444,0.659,6.732,1.723,9.732h-62.26c-16.635,0-30.132,13.357-30.132,30 s13.497,30,30.132,30h175.834c16.636,0,30.132-13.357,30.132-30S611.152,933.249,594.516,933.249z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M758.392,346.334c-9.008-13.975-27.684-17.977-41.667-8.969L519.264,464.902l-36.943-98.495 c-3.217-8.561-10.138-15.199-18.817-18.048c-8.663-2.872-18.174-1.608-25.848,3.374L232.615,485.257 c-13.936,9.079-17.891,27.747-8.804,41.691c5.775,8.875,15.427,13.693,25.283,13.693c5.634,0,11.331-1.577,16.416-4.881 l173.575-113.035l36.881,98.369c3.201,8.538,10.107,15.16,18.754,18.024c8.647,2.864,18.158,1.664,25.816-3.296l228.896-147.829 C763.398,378.962,767.416,360.31,758.392,346.334z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgDemo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024.497 1024.497",
    style: {
      enableBackground: "new 0 0 1024.497 1024.497"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemo);
export default __webpack_public_path__ + "static/media/demo.4dabeef9.svg";
export { ForwardRef as ReactComponent };